import React from 'react';
import { Box, Typography } from '@mui/material';

const listItemStyle = {
    marginBottom: '0.75rem',
};

const WebsiteMonitorSection = () => {
    return (
        <Box sx={{ px: { xs: 2, sm: 4 }, py: 2 }}>
            <Typography paragraph>
                The API Monitor Page allows users to monitor endpoints. It includes a submission form and a table that displays all monitored API and their latest status.
            </Typography>

            {/* Key Features */}
            <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
                Key Features
            </Typography>
            <ul style={{ paddingLeft: '1.25rem' }}>
                <li style={listItemStyle}>
                    <Typography variant="body1">
                        <strong>User Input Form:</strong> Includes a dropdown to select a subscription plan and a field to input the domain to be monitored.
                    </Typography>
                </li>
                <li style={listItemStyle}>
                    <Typography variant="body1">
                        <strong>Watch List Table:</strong> Shows all added domains with the following details:
                    </Typography>
                    <ul style={{ paddingLeft: '1.5rem', marginTop: '0.5rem' }}>
                        <li style={listItemStyle}><Typography variant="body1">Endpoint</Typography></li>
                        <li style={listItemStyle}><Typography variant="body1">Last Status Check Result</Typography></li>
                        <li style={listItemStyle}><Typography variant="body1">Date and Time Added</Typography></li>
                        <li style={listItemStyle}><Typography variant="body1">Action buttons (View and Delete)</Typography></li>
                    </ul>
                </li>
                <li style={listItemStyle}>
                    <Typography variant="body1">
                        <strong>View Button:</strong> Opens a popup with the five most recent status check results.
                    </Typography>
                </li>
                <li style={listItemStyle}>
                    <Typography variant="body1">
                        <strong>Delete Button:</strong> Permanently removes a domain entry.
                    </Typography>
                </li>
            </ul>
            <Typography variant="body1" color="text.secondary" >
                Note: Deleted domains and their history are unrecoverable.
            </Typography>

            {/* Interaction Flow */}
            <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
                Interaction Flow
            </Typography>
            <ul style={{ paddingLeft: '1.25rem' }}>
                <li style={listItemStyle}>
                    <Typography variant="body1">Select a subscription and enter the Endpoint.</Typography>
                </li>
                <li style={listItemStyle}>
                    <Typography variant="body1">The domain appears in the list on the same page.</Typography>
                </li>
                <li style={listItemStyle}>
                    <Typography variant="body1">Use the View button to inspect recent status checks.</Typography>
                </li>
                <li style={listItemStyle}>
                    <Typography variant="body1">Use the Delete button to remove the domain.</Typography>
                </li>
            </ul>
        </Box>
    );
};

export default WebsiteMonitorSection;
